import { Accept, useDropzone } from 'react-dropzone';
import s from './drop-zone.module.css';
import { FC } from 'react';
import { useLang } from '../../hooks/use-lang';
import { UploadCloudIcon } from '../../assets/svg/upload-cloud';
import cn from 'classnames';

interface Props {
  onDrop: (file: File) => void;
  acceptedFiles?: Accept;
  helpText?: string;
  disabled?: boolean;
  disabledText?: string;
}

export const DropZone: FC<Props> = (props) => {
  const { onDrop, acceptedFiles, helpText, disabled, disabledText } = props;
  const { t } = useLang();

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedFiles || { 'text/csv': ['.csv'], 'spreadsheet/xlsx': ['.xlsx'] },
    multiple: false,
    onDrop: (acceptedFiles) => {
      onDrop(acceptedFiles[0]);
    },
  });

  return (
    <div {...getRootProps()} className={cn(s.feature, disabled && s.disabled)}>
      <UploadCloudIcon />

      <input {...getInputProps()} />
      <p className={s.title}>
        {disabled ? (
          disabledText || t('Функция не доступна')
        ) : (
          <>
            {t('Перетащите файл сюда или')} <span className={s.press}>{t('Нажмите')}</span>
          </>
        )}
      </p>
      {helpText && <span className={s.help}>{t(helpText)}</span>}
    </div>
  );
};
